import getEnv from './get-env.js'

const getCookieDomain = () => {
  let cookieDomain = getEnv('REACT_APP_TOKEN_COOKIE_DOMAIN')
  if (cookieDomain) {
    return cookieDomain
  }

  const hostname = window.location.hostname
  const parts = hostname.split('.')
  const cookieDomainParts = parts.slice(parts.length - 2, parts.length)
  cookieDomain = cookieDomainParts.join('.')
  return `.${cookieDomain}`
}

export default getCookieDomain
